import React from "react";
import {
  Routes,
  Route,
  Link,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { createLoginUrlWithReturn } from "utils/authUtils";

const ProtectedRoute = ({
  isAllowed,
  currentUser,
  redirectPath = "/Login/",
  children,
}) => {
  const location = useLocation();

  if (!isAllowed) {
    // Create login URL with current path as return URL
    const loginUrlWithReturn = createLoginUrlWithReturn(
      location.pathname + location.search
    );
    return <Navigate to={loginUrlWithReturn} replace />;
  } else {
    return children ? children : <Outlet />;
    // if (currentUser.User_Type_Id === 2)
    //   return <Navigate to={"/CustomErrors/" + 305} replace />;
    // else return children ? children : <Outlet />;
  }
};

export default ProtectedRoute;
